import { PersonAvatar } from '@/components/common/PersonAvatar';
import { INK } from './taskTheme';
import type { AssignedUser } from '@/types/task';

interface TaskPersonProps {
  person: Pick<AssignedUser, 'display_name' | 'image_url'> | null;
  /** Shown in place of a name when nobody holds the role. */
  empty?: string;
}

/**
 * A person's avatar and name, or an em dash when the role is empty.
 *
 * One scale everywhere it appears — the board's property cells, the panel's
 * property rows, the value menus: a 16px avatar on the shared 7px
 * icon-to-text gap, with the name in the board's own ink. The panel used to
 * take a larger 22px avatar and a softer grey, which made a person read as a
 * different kind of value from the status, dates and source beside it.
 */
export const TaskPerson = ({ person, empty = '—' }: TaskPersonProps) => {
  if (!person) {
    return <span className="text-[#B7B4AC]">{empty}</span>;
  }

  return (
    <span className="inline-flex min-w-0 items-center gap-[7px]">
      <PersonAvatar person={person} className="size-4 text-[8px]" />
      <span className={`truncate text-[13.5px] ${INK}`}>{person.display_name}</span>
    </span>
  );
};
